import { Card, CardContent, Grid } from "@mui/material";
import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey } from "assets/jss/common-styles";
import { RequestWrapIndicator } from "components/CallServer/RequestWrapIndicator";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import { PublicationVisility } from "models/ApiEnums";
import * as React from "react";
import BodyPoll from "views/Timeline/Components/CardComp/BodyPoll";
import FooterLine from "views/Timeline/Components/CardComp/FooterLine";
import HeaderLine from "views/Timeline/Components/CardComp/HeaderLine";
import IconsLine from "views/Timeline/Components/CardComp/IconsLine";
import TitleLine from "views/Timeline/Components/CardComp/TitleLine";
import { RenderDefaultApprovalAction, RenderDenouncementAction, RenderPollActions } from "views/Timeline/Components/CardFactory/CommonRenders";
import { CardCommonActions } from "views/Timeline/Components/CardLib/CardCommonActions";
import { PollCardSetup } from "views/Timeline/Components/CardLib/CardSetup";
import { ICardProps } from "views/Timeline/Components/CardLib/ICardProps";
import Delete from "views/Timeline/Dialogs/PublicationDelete";
import Edit from "views/Timeline/Dialogs/PublicationEdit";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    mouseOver: boolean;
    showBody: boolean;
    dialog: any;
}

type Props = ICardProps & WithSnackbar & StyledComponentProps<FeedClassKey>;

/////////////////////////////////////////////////////////////////////////////////////

class PollCard extends React.PureComponent<Props, IState> {

    private commonActions: CardCommonActions;

    constructor(props: Props) {
        super(props);
        this.state = {
            dialog: null,
            mouseOver: false,
            showBody: null
        };

        this.commonActions = new CardCommonActions(props.onUpdateCard, props.snackbar.showMessage);
    }

    ///
    private processEdit = () => {
        const { item } = this.props;

        if (this.props.onBeforeEdit) {
            this.setState({ mouseOver: false });
            if (!this.props.onBeforeEdit()) return;
        }

        this.setState({
            mouseOver: false,
            dialog: (
                <Edit
                    data={item}
                    onClose={
                        (update: boolean) => {
                            if (update) {
                                this.props.onReloadPublication();
                            }
                            this.setState({ dialog: null });
                        }
                    }
                />
            )
        });
    };

    ///
    private processDelete = () => {
        const { item } = this.props;

        this.setState({ mouseOver: false });

        new Promise<boolean>((resolve) => {
            if (this.props.onBeforeDelete) {
                this.props.onBeforeDelete()
                    .then((result) => resolve(result));
            }
            else
                resolve(false);
        }).then((handled) => {

            if (!handled) {
                this.setState({
                    dialog: (
                        <Delete
                            data={item}
                            onRemovePublication={this.props.onRemovePublication}
                            onClose={() => this.setState({ dialog: null })}
                        />)
                });
            }
        });
    };

    ///
    private processPublish = () => {
        this.setState({ mouseOver: false });
        this.props.onPublishPublication();
    };

    ///
    private processVisibility = () => {

        this.setState({
            mouseOver: false,
        });

        this.props.onChangePublicationVisibility(
            this.props.item.interaction.visibility == PublicationVisility.Hidden
                ? PublicationVisility.Visible
                : PublicationVisility.Hidden
        );
    };

    ///
    private handleTextExpand = (textExpanded: boolean) => {
        this.commonActions.expandText(this.props.item, textExpanded);
    };

    ///
    public render() {
        const {
            classes,
            item,
            feedType,
            onUpdateCard,
            onApprovalRequest,
            onSidebarResetRequest
        } = this.props;

        const { mouseOver } = this.state;

        const env = new PollCardSetup(this.props, this.state.showBody, this.processEdit, this.processDelete, this.processPublish, this.processVisibility);

        return (
            <>
                <Card
                    id={item.publicationId}
                    className={classes.card}
                    onMouseEnter={() => this.setState({ mouseOver: true })}
                    onMouseLeave={() => this.setState({ mouseOver: false })
                    }
                >
                    <RequestWrapIndicator enabled={item.isUpdating} type="update">

                        <CardContent className={classes.cardContent}>

                            <Grid container>
                                <Grid item xs>
                                    { /* Area 1 */}
                                    <HeaderLine
                                        classes={classes}
                                        data={item}
                                        feedType={this.props.feedType}
                                        fullView={env.fullView}
                                        inApprovalMode={env.inApprovalMode}
                                        mouseOver={mouseOver}
                                        textExpanded={env.textExpanded}
                                        topMessageMode={env.topMessageMode}
                                        onUpdateCard={onUpdateCard}
                                    />

                                    { /* Area 3 */}
                                    <TitleLine
                                        classes={classes}
                                        data={item}
                                        feedType={this.props.feedType}
                                        fullView={env.fullView}
                                        onTitleClick={env.titleHandle}
                                    />
                                </Grid>
                                <Grid item>
                                    { /* Area 2 */}
                                    <IconsLine
                                        data={item}
                                        feedType={this.props.feedType}
                                        mouseOver={mouseOver}
                                        textExpanded={item.body.fullContentLoaded}
                                        classes={classes}
                                        onEditPublication={env.editHandle}
                                        onHidePublication={env.visibilityHandle}
                                        onRemovePublication={env.deleteHandle}
                                        onViewLater={item.permissions.canViewLater ? this.commonActions.viewLater : null}
                                        onTextExpandedChange={this.handleTextExpand}
                                        onCustomAction={this.props.onCustomAction}
                                    />
                                </Grid>
                            </Grid>

                            {
                                /* Area 4, 5 e 6 */
                                <BodyPoll
                                    classes={classes}
                                    data={item}
                                    fullView={env.fullView}
                                    feedType={this.props.feedType}
                                    onUpdateCard={onUpdateCard}
                                />
                            }


                            {/* Area 7 */}
                            {
                                !env.inApprovalMode
                                    ? <RenderPollActions
                                        classes={classes}
                                        item={item}
                                        feedType={feedType}
                                        fullView={env.fullView}
                                        showRelationsButton={false}
                                        onSidebarResetRequest={onSidebarResetRequest}
                                        onUpdateCard={onUpdateCard}
                                        onEdit={env.editHandle}
                                        onDelete={env.deleteHandle}
                                        onReloadPublication={env.reloadHandle}
                                    />
                                    : env.isDenouncement
                                        ? <RenderDenouncementAction
                                            classes={classes}
                                            item={item}
                                            hasBody={env.hasBody}
                                            showBody={env.showBody}
                                            onApprovalRequest={onApprovalRequest}
                                            onExpandText={this.handleTextExpand}
                                            onUpdateCard={onUpdateCard}
                                        />
                                        : <RenderDefaultApprovalAction
                                            classes={classes}
                                            item={item}
                                            hasBody={env.hasBody}
                                            showBody={env.showBody}
                                            onApprovalRequest={onApprovalRequest}
                                            onExpandText={this.handleTextExpand}
                                            onUpdateCard={onUpdateCard}
                                        />
                            }
                        </CardContent>

                        <FooterLine
                            classes={classes}
                            data={item}
                            fullView={env.fullView}
                        />


                    </RequestWrapIndicator>
                </Card>

                {this.state.dialog}
            </>
        );
    }
}

export default withSnackbar(PollCard);